import { DateTime } from "luxon";
import { createContext, useContext } from "react";

interface TimestampContextValue {
  now: DateTime<true>;
}

const distantPast = DateTime.fromMillis(0) as DateTime<true>;

/** Provides a periodically refreshing "now" timestamp for rendering relative timestamps in the UI without illegal side-effects. */
export const TimestampContext = createContext<TimestampContextValue>({
  get now() {
    console.warn(
      "Missing <TimestampProvider> needed to properly render timestamps",
    );

    return distantPast;
  },
});

export function useNow() {
  return useContext(TimestampContext).now;
}
